import { useEffect } from "react";
import { useFooterContent } from "@/hooks/useFooterContent";

const DynamicFavicon = () => {
  const { data: footerContent } = useFooterContent();

  useEffect(() => {
    if (footerContent?.favicon_url) {
      // Remove existing favicons
      const existingLinks = document.querySelectorAll("link[rel*='icon']");
      existingLinks.forEach((link) => link.remove());

      // Create new favicon link
      const link = document.createElement("link");
      link.rel = "icon";
      link.href = footerContent.favicon_url;
      link.type = "image/png";
      document.head.appendChild(link);
    }
  }, [footerContent?.favicon_url]);

  return null;
};

export default DynamicFavicon;
